import Cookies from "universal-cookie";
const cookies = new Cookies();
export const LOGIN_IMAGE_CACHE_KEY = "ag-login-images";

export const Logout = async (e: any = null) => {
  if (e) e.preventDefault();
  const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN || undefined;
  const expire = "Thu, 01 Jan 1970 00:00:01 GMT";
  document.cookie = `skyToken=; Path=/; Expires=${expire}; Max-Age=0`;
  document.cookie = `skyToken=; Path=/; Expires=${expire}; Max-Age=0; SameSite=Lax`;
  if (cookieDomain) {
    document.cookie = `skyToken=; Path=/; Domain=${cookieDomain}; Expires=${expire}; Max-Age=0`;
    cookies.remove("skyToken", { domain: cookieDomain, path: "/" });
  }
  cookies.remove("skyToken", { path: "/" });
  cookies.remove("skyToken");
  localStorage.removeItem("persist:root");
  const keptLoginImages = localStorage.getItem(LOGIN_IMAGE_CACHE_KEY);
  localStorage.clear();
  if (keptLoginImages) {
    localStorage.setItem(LOGIN_IMAGE_CACHE_KEY, keptLoginImages);
  }
  sessionStorage.clear();
  window.location.reload();

};

// export const getImageUrl = (path: String) => {
//     return (process.env.REACT_APP_BASE_POINT ? process.env.REACT_APP_BASE_POINT : '') + path
// }

export const getImageUrl = (path?: string | null) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  return `${process.env.REACT_APP_BASE_POINT || ""}/${path}`;
};

export type CachedLoginImages = {
  host: string;
  loginImage: string;
  mobileLoginImage: string;
  loginImageUrl: string;
  mobileLoginImageUrl: string;
  agLoginLogo?: string;
  agLoginLogoUrl?: string;
  theme?: string;
  agLoginDesign?: string;
};

export const readCachedLoginImages = (): CachedLoginImages | null => {
  try {
    const raw = localStorage.getItem(LOGIN_IMAGE_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.host !== window.location.hostname) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const readCachedAgLoginDesign = (): "velki" | "default" | "" => {
  const cached = readCachedLoginImages();
  if (!cached?.theme) return "";
  return cached.agLoginDesign === "velki" ? "velki" : "default";
};

export const cacheLoginImages = (site?: {
  loginImage?: string;
  mobileLoginImage?: string;
  agLoginLogo?: string;
  theme?: string;
  agLoginDesign?: string;
} | null) => {
  if (!site) return;
  const loginImage = String(site.loginImage || "");
  const mobileLoginImage = String(site.mobileLoginImage || "");
  const agLoginLogo = String(site.agLoginLogo || "");
  const theme = site.theme === "velki" ? "velki" : "sky-sky";
  const agLoginDesign = site.agLoginDesign === "velki" ? "velki" : "default";
  const payload: CachedLoginImages = {
    host: window.location.hostname,
    loginImage,
    mobileLoginImage,
    loginImageUrl: getImageUrl(loginImage),
    mobileLoginImageUrl: getImageUrl(mobileLoginImage),
    agLoginLogo,
    agLoginLogoUrl: getImageUrl(agLoginLogo),
    theme,
    agLoginDesign,
  };
  if (agLoginDesign === "velki" && window.location.pathname === "/login") {
    const preload = new Image();
    preload.src = `${process.env.PUBLIC_URL || ""}/velki-ag-bg.jpg`;
  }
  try {
    localStorage.setItem(LOGIN_IMAGE_CACHE_KEY, JSON.stringify(payload));
  } catch {
    return;
  }
  if (agLoginDesign === "velki") {
    document.documentElement.style.removeProperty("--ag-login-image");
    return;
  }
  const href =
    payload.agLoginLogoUrl ||
    (window.outerWidth < 577
      ? payload.mobileLoginImageUrl || payload.loginImageUrl
      : payload.loginImageUrl || payload.mobileLoginImageUrl);
  if (!href) {
    document.documentElement.style.removeProperty("--ag-login-image");
    return;
  }
  const safe = href.replace(/["\\]/g, "");
  document.documentElement.style.setProperty(
    "--ag-login-image",
    `url("${safe}")`,
  );
};

const FAVICON_CACHE_KEY = "site-favicon";

const isUploadedIcon = (href: string) => /^https?:\/\//i.test(href);

const rememberFavicon = (href: string) => {
  try {
    localStorage.setItem(
      FAVICON_CACHE_KEY,
      JSON.stringify({ host: window.location.hostname, href }),
    );
  } catch {
    return;
  }
};

const readCachedFavicon = () => {
  try {
    const data = JSON.parse(localStorage.getItem(FAVICON_CACHE_KEY) || "");
    if (!data || data.host !== window.location.hostname) return "";
    const href = String(data.href || "");
    return isUploadedIcon(href) ? href : "";
  } catch {
    return "";
  }
};

const upsertIconLink = (id: string, rel: string, href: string) => {
  let link = document.getElementById(id) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.id = id;
    document.head.appendChild(link);
  }
  link.rel = rel;
  link.removeAttribute("sizes");
  link.removeAttribute("type");
  if (link.getAttribute("href") !== href) {
    link.setAttribute("href", href);
  }
};

/** Use the uploaded file unchanged. No placeholder artwork and no resize. */
export const applySiteFavicon = (domainDetails?: any) => {
  if (typeof document === "undefined") return;
  const uploaded =
    domainDetails?.favicon && String(domainDetails.favicon).trim()
      ? getImageUrl(String(domainDetails.favicon).trim())
      : "";
  const href = isUploadedIcon(uploaded) ? uploaded : readCachedFavicon();
  if (!href) return;
  rememberFavicon(href);
  upsertIconLink("site-favicon", "icon", href);
  upsertIconLink("site-apple-touch-icon", "apple-touch-icon", href);
};

/**
 * Formats a value with comma separators.
 * - 0, empty, or invalid input -> "0.00"
 * - Whole numbers have no decimals (1234 -> "1,234")
 * - Decimals show up to 3 digits, no extra zeros (0.1 -> "0.1")
 */

export const formatNumberComma3dp = (value: any): string => {
  let num: number;
  if (typeof value === "number") {
    num = value;
  } else if (value === null || value === undefined || value === "") {
    num = 0;
  } else {
    const parsed = Number(String(value).replace(/,/g, ""));
    num = Number.isFinite(parsed) ? parsed : 0;
  }

  // Zero, NaN, or Infinity -> "0.00"
  if (!Number.isFinite(num) || num === 0) return "0.00";

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(num);
};

/**
 * Removes negative sign from a number by converting it to absolute value.
 * Used to display ref_pl values without negative signs.
 * The color (red/black) is determined by checking if credit_ref is greater than balance.
 */
export const removeNegative = (num: number) => {
  if (isNaN(num)) return "0.00";
  return Math.abs(num);
};

export async function getLoginLocation() {
  const empty = { city: "", state: "", country: "", ISP: "" };
  const url = process.env.REACT_APP_IP_WHO_URL || "";
  if (!url) {
    return empty;
  }
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 4000);
  try {
    const res = await fetch(url, { signal: controller.signal });
    const data = await res.json();
    return {
      city: data?.city || "",
      state: data?.region || "",
      country: data?.country || "",
      ISP: data?.connection?.org || "",
    };
  } catch {
    return empty;
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export function readLoginFields(
  e: any,
  fallback: { username?: string; user_name?: string; password?: string } = {},
) {
  const target = e?.currentTarget || e?.target;
  const root: ParentNode | Document =
    (target instanceof HTMLFormElement && target) ||
    target?.closest?.("form") ||
    target?.closest?.(".login-wrap") ||
    target?.closest?.(".login_form") ||
    target?.closest?.(".login_form_main") ||
    target?.closest?.(".form-info") ||
    target?.closest?.(".w-60") ||
    target?.closest?.(".login_main") ||
    document;
  const valueOf = (name: string) => {
    const el = root.querySelector?.(
      `[name="${name}"]`,
    ) as HTMLInputElement | null;
    return el && typeof el.value === "string" ? el.value : "";
  };
  const username = String(
    valueOf("user_name") ||
      valueOf("username") ||
      fallback.user_name ||
      fallback.username ||
      "",
  ).trim();
  const password = String(valueOf("password") || fallback.password || "");
  return { username, password };
}

export function getBrowser() {
  "use strict";

  var module = {
    options: [],
    header: [
      navigator.platform,
      navigator.userAgent,
      navigator.appVersion,
      navigator.vendor,
    ],
    dataos: [
      { name: "Windows Phone", value: "Windows Phone", version: "OS" },
      { name: "Windows", value: "Win", version: "NT" },
      { name: "iPhone", value: "iPhone", version: "OS" },
      { name: "iPad", value: "iPad", version: "OS" },
      { name: "Kindle", value: "Silk", version: "Silk" },
      { name: "Android", value: "Android", version: "Android" },
      { name: "PlayBook", value: "PlayBook", version: "OS" },
      { name: "BlackBerry", value: "BlackBerry", version: "/" },
      { name: "Macintosh", value: "Mac", version: "OS X" },
      { name: "Linux", value: "Linux", version: "rv" },
      { name: "Palm", value: "Palm", version: "PalmOS" },
    ],
    databrowser: [
      { name: "Chrome", value: "Chrome", version: "Chrome" },
      { name: "Firefox", value: "Firefox", version: "Firefox" },
      { name: "Safari", value: "Safari", version: "Version" },
      { name: "Internet Explorer", value: "MSIE", version: "MSIE" },
      { name: "Opera", value: "Opera", version: "Opera" },
      { name: "BlackBerry", value: "CLDC", version: "CLDC" },
      { name: "Mozilla", value: "Mozilla", version: "Mozilla" },
    ],
    init: function () {
      var agent = this.header.join(" "),
        os = this.matchItem(agent, this.dataos),
        browser = this.matchItem(agent, this.databrowser);

      return { os: os, browser: browser };
    },
    matchItem: function (string: string | any, data: string | any[]) {
      var i = 0,
        j = 0,
        html = "",
        regex,
        regexv,
        match,
        matches,
        version;

      for (i = 0; i < data.length; i += 1) {
        regex = new RegExp(data[i].value, "i");
        match = regex.test(string);
        if (match) {
          regexv = new RegExp(data[i].version + "[- /:;]([\\d._]+)", "i");
          matches = string.match(regexv);
          version = "";
          if (matches) {
            if (matches[1]) {
              matches = matches[1];
            }
          }
          if (matches) {
            matches = matches.split(/[._]+/);
            for (j = 0; j < matches.length; j += 1) {
              if (j === 0) {
                version += matches[j] + ".";
              } else {
                version += matches[j];
              }
            }
          } else {
            version = "0";
          }
          return {
            name: data[i].name,
            version: parseFloat(version),
          };
        }
      }
      return { name: "unknown", version: 0 };
    },
  };

  var e = module.init();

  return {
    OSname: e.os.name,
    OSversion: e.os.version,
    BrowserName: e.browser.name,
    BrowserVersion: e.browser.version,
  };
}

export const getBetTable = (TABLE: string) => {
  switch (TABLE) {
    case "odds":
      return "t1";
    case "bookMark":
      return "t2";
    case "session":
      return "t3";
    case "premium":
      return "t4";
    default:
      break;
  }
};

/**
 * Captcha visibility — safe for existing sites:
 * - explicit false/true from website settings wins
 * - if unset, same as before: REACT_APP_CAPTCHA !== "false"
 */
export const isCaptchaEnabled = (
  siteValue: unknown,
  envValue: string | undefined = process.env.REACT_APP_CAPTCHA,
) => {
  if (siteValue === false) return false;
  if (siteValue === true) return true;
  return envValue !== "false";
};

export function descendingComparator(
  a: { [x: string]: number },
  b: { [x: string]: number },
  orderBy: string | number,
) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order: string, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

export function stableSort(
  array: any[],
  comparator: (arg0: any, arg1: any) => any,
) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: number[], b: number[]) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any[]) => el[0]);
}
